import Loading from "@components/loading/index.jsx";
import AccountInsightsErrorState from "@pages/profile-v2/pages/account-insights/components/AccountInsightsErrorState";
import React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { showAlert } from "@components/alert/action";
import { getEnabledLimitTypes } from "./constants";
import { LimitsLimitSection } from "./components";
import { IntroText, PageWrapper, SectionCard } from "./elements";
import useController from "./useController";

const LimitsContent = ({ translate, showAlert }) => {
	const { state, handlers } = useController();

	if (state.isLoading) {
		return (
			<PageWrapper>
				<SectionCard>
					<Loading loading />
				</SectionCard>
			</PageWrapper>
		);
	}

	if (state.isError) {
		return (
			<PageWrapper>
				<SectionCard>
					<AccountInsightsErrorState
						translate={translate}
						onRetry={handlers.refetch}
					/>
				</SectionCard>
			</PageWrapper>
		);
	}

	return (
		<PageWrapper>
			<IntroText>{translate("limits.intro")}</IntroText>
			{getEnabledLimitTypes().map((type) => (
				<LimitsLimitSection
					key={type}
					type={type}
					limits={state.limits}
					currency={state.currency}
					translate={translate}
					showAlert={showAlert}
					isLoading={false}
				/>
			))}
		</PageWrapper>
	);
};

const Limits = ({ showAlert }) => (
	<Translate>
		{({ translate }) => (
			<LimitsContent
				translate={translate}
				showAlert={showAlert}
			/>
		)}
	</Translate>
);

const mapDispatchToProps = { showAlert };

export default connect(null, mapDispatchToProps)(Limits);
